import "./Notes.css";
import "../../styles/reset.css";
import React from "react";
import Note from "./Note";
import NoteForm from "../noteForm/noteForm";

class Notes extends React.Component {
    renderNote(i) {
        return (
            <Note note={this.props.notes[i]}
                  onClick={() => this.props.handleClick(i)}
            />
        );
    }

    renderNoteForm(i) {
        return (
            <NoteForm appearances={this.props.appearances}
                      newNote={this.props.notes[i]}
                      handleClickColor={(color) => this.props.handleClickColor(i, color)}
                      handleInput={(e) => this.props.handleInput(i, e)}
                      handleDelete={() => this.props.handleDeleteNote(i)}
                      handleReset={() => this.props.handleResetNote(i)}
                      handleSubmit={() => this.props.handleSubmitNote(i)}
            />
        );
    }

    renderNoteOrNoteForm(i) {
        if (this.props.notes[i].expanded) {
            return this.renderNoteForm(i);
        }
        return this.renderNote(i);
    }

    render() {
        let numbers = [...Array(this.props.notes.length).keys()];
        const noteItems = numbers.map((number) =>
            <React.Fragment>{this.renderNoteOrNoteForm(number)}</React.Fragment>
        );
        return (
            <section className="notes-feed">
                {noteItems}
            </section>
        );
    }
}

export default Notes;
